import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';
import { isYes } from '../../../../../../../components/loan_application/utils/helpers';

const { borrowerAttestsNoDebtPick } = loanFormModel.formField;

class HasOtherOutstandingLoanObligations implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const hasOtherObligations = isYes(
      application[borrowerAttestsNoDebtPick.name]
    );

    return hasOtherObligations;
  }
}

export default new HasOtherOutstandingLoanObligations();
